const translations = {
  de: {
    checkout: {
      checking_out_label: 'Zur Zahlung gehen...',
      checkout_label: 'Zur Kasse gehen',
      continue_shopping_label: 'Weiter einkaufen',
      view_cart_label: 'Warenkorb anzeigen',
    },
    smart_cart: {
      cart_title: 'Dein Warenkorb',
      empty_cart: 'Dein Warenkorb ist noch leer! Fülle ihn mit deinen Lieblingsprodukten!',     
      subtotal_plural_text: "Artikels (<span class='item-count'></span>)",
      subtotal_singular_text: "Artikel (<span class='item-count'></span>)",
    },
    announcement_bar: {
      bars: [
        {
          free_shipping_remaining: "Du bist {{remaining_amount}} vom kostenlosen Versand entfernt",
          free_shipping_reached: "Du hast kostenlosen Versand!",
        }
      ]
    },
    empty: {
      title: 'Ihr Warenkorb ist leer',
      button: "Jetzt shoppen"
    }
  },
  da: {
    checkout: {
      checking_out_label: 'Går til checkout...',
      checkout_label: 'Gå til checkout',
      continue_shopping_label: 'Fortsæt med at shoppe',
      view_cart_label: 'Vis kurv',
    },
    smart_cart: {
      cart_title: 'Kurv',
      empty_cart: 'Din indkøbskurv er tom! Fyld den med dine yndlingsprodukter!',
      subtotal_plural_text: "Varer (<span class='item-count'></span>)",
      subtotal_singular_text: "Vare (<span class='item-count'></span>)",
    },
    announcement_bar: {
      bars: [
        {
          free_shipping_remaining: "Du mangler {{remaining_amount}} for at opnå gratis fragt",
          free_shipping_reached: "Du har opnået gratis fragt!",          
        }
      ]
    },
    empty: {
      title: 'Din kurv er tom',
      button: "Shop nu"
    }
  },
  no: {
    checkout: {
      checking_out_label: 'Går til kassen...',
      checkout_label: 'Gå til kassen',
      continue_shopping_label: 'Fortsett å handle',
      view_cart_label: 'Se handlekurv',
    },
    smart_cart: {
      cart_title: 'Din Handlekurv',
      empty_cart: 'Handlekurven din er tom! Fyll den med dine favorittprodukter!',
      subtotal_plural_text: "Varer (<span class='item-count'></span>)",
      subtotal_singular_text: "Vare (<span class='item-count'></span>)",
    },
    announcement_bar: {
      bars: [
        {
          free_shipping_remaining: "Du er {{remaining_amount}} unna gratis frakt",
          free_shipping_reached: "Du har fått gratis frakt!",
        }
      ]
    },
    empty: {
      title: 'Handlekurven din er tom',
      button: "Shop nå"
    }
  },
  sv: {
    checkout: {
      checking_out_label: 'Går till kassan...',
      checkout_label: 'Gå till kassan',
      continue_shopping_label: 'Fortsätt handla',
      view_cart_label: 'Visa varukorg',
    },
    smart_cart: {
      cart_title: 'Din Varukorg',
      empty_cart: 'Din varukorg är tom! Fyll den med dina favoritprodukter!',
      subtotal_plural_text: "Varor (<span class='item-count'></span>)",
      subtotal_singular_text: "Vara (<span class='item-count'></span>)",
    },
    announcement_bar: {
      bars: [
        {
          free_shipping_remaining: "Du är {{remaining_amount}} ifrån fri frakt",
          free_shipping_reached: "Du har fått fri frakt!",
        }
      ]
    },
    empty: {
      title: 'Din varukorg är tom',
      button: "Handla nu"
    }
  }
};

const updateTranslations = () => {
  const locale = Shopify?.locale;
  const translation = translations[locale] ?? translations.en;

  if (locale && translation) {
    if (Rebuy) {      
      Rebuy.SmartCart.getCheckoutSettings().language = translation.checkout;
    }

    const cartDrawer = document.querySelector('.rebuy-cart');

    if (cartDrawer) {
      const cartTitle = cartDrawer.querySelector('.rebuy-cart__title');

      if (cartTitle) {
        cartTitle.innerHTML = translation.smart_cart.cart_title;
      }
    }
  }
};

const updateEmptyCartTranslations = () => {
  const locale = Shopify?.locale;
  const translation = translations[locale] ?? translations.en;

  if (locale && translation) {
    const emptyCartTitle = document.querySelector('.rebuy-cart__flyout-empty-cart h4');
    const emptyCartButton = document.querySelector('.rebuy-cart__flyout-empty-cart p a');

    if(emptyCartTitle && emptyCartButton) {
      emptyCartTitle.innerHTML = translation.empty.title;
      emptyCartButton.innerHTML = translation.empty.button;
    }
  }
};

const updateAnnouncementBar = () => {
  const locale = Shopify?.locale;
  const announcementTranslations = translations[locale]?.announcement_bar.bars;
  const components = Rebuy.SmartCart.settings.components;

  if (announcementTranslations) {
    const announcementBar = components.find(c => c.type === 'tiered_progress_bar')

    if(!announcementBar) {
      return;
    }

    announcementBar.settings.bars.forEach((bar, index) => {
      const translation = announcementTranslations[index];

      if (translation) {
        bar.language = translation;
      }
    });
  }
}

// Update Smart Cart with locale translations
document.addEventListener('rebuy:smartcart.ready', () => {
  updateTranslations();
  updateAnnouncementBar();

  // Every 100ms update translations
  setInterval(() => {
    updateEmptyCartTranslations();
  }, 200);
});

document.addEventListener('rebuy:cart.change', () => {
  updateTranslations();
  updateEmptyCartTranslations();
  updateAnnouncementBar();
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
  updateTranslations();
});